export const supplierAccountQueryKeys = {
  all: ['supplier-account'] as const,
  profile: ['supplier-account', 'profile'] as const,
  accounts: (companyCode: string) => ['supplier-account', 'companies', companyCode, 'accounts'] as const,
  account: (companyCode: string, userId: number) => ['supplier-account', 'companies', companyCode, 'accounts', userId] as const,
  permissionTree: (userId: number) => ['supplier-account', 'permission-tree', userId] as const,
}
